import React from "react";
import Button from "../Form/CustomButton";
import TimeCalculator from "../Common/TimeCalculator";
import { useNavigate } from "react-router-dom";
import RenderImage from "../Common/RenderImage";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";
import { useSelector } from "react-redux";
import { useThunk } from "../../hooks/useThunk";
import { createThread } from "../../store/thunks/threadThunks";
import showToast from "../../utils/toastNotifications";
import { ErrorCodes } from "../../constants/errorCodes";

const TaskerFeedJobCard = ({
  key,
  title,
  lastUpdatedDate,
  image,
  location,
  jobTasks,
  date,
  time,
  createdBy = ""
}) => {
  const navigate = useNavigate();

  const userState = useSelector(state => state?.auth?.user);

  const formattedDate = date ? formatYYYY_MM_DD(date) : "";
  const formattedTime = time ? time : "";
    // ? new Date(`1970-01-01T${time}:00`).toLocaleTimeString("en-US", {
    //     hour: "2-digit",
    //     minute: "2-digit",
    //     hour12: true,
    //   })
    // : "";

  const [doCreateThread, isCreateThread, errorCreateThread] = useThunk(createThread);

  // FUNCTION: handle chat now button click
  const handleStartChat = async(user2Id) => {
    if(user2Id){
      const response = await doCreateThread(user2Id);
      if(response?.success){
        navigate(`/chat?thread=${response?.response?.data?._id}`)
      }else{
        if(response?.error?.customCode === ErrorCodes.DUPLICATE_ENTRIES.code){
          navigate(`/chat?thread=${response?.error?.message?.split(":")[1]?.toString()?.trim()}`)
        }else{
          showToast("error", response?.error?.message || "Error Occured");
        }
      }
    }else{
      showToast("error", "User ID Not Provided");
    }
  }

  return (
    <div
      key={key}
      className="flex flex-col w-full p-4 lg:p-6 bg-white hover:bg-lightyellow border lg:flex-row sm:p-9 rounded-[12px] border-[#DDE1E6] gap-4"
    >
      <div className="block text-left lg:hidden md:hidden">
        <p className="text-[var(--subtle-text)] font-inter font-semibold leading-6 md:text-[18px] text-[14px]">
          <TimeCalculator date={lastUpdatedDate} />
        </p>
      </div>

      {/* Card - Left Section */}
      <div className="w-full lg:max-w-[200px] flex flex-col items-center md:items-center lg:items-start">
        <div className="flex flex-col md:items-center gap-4 sm:flex-row sm:gap-[34px]">
          <div className="flex-shrink-0">
            {/* <div className="object-cover w-full h-auto md:w-32 rounded-[4px] sm:w-40 sm:h-32 lg:w-[188px] lg:h-[149px]">
              <img src={image} alt="jobPic" />
            </div> */}
            {/* <img
              src={image}
              alt="jobPic"
              // className="object-cover w-full h-auto md:w-32 rounded-[4px] sm:w-40 sm:h-32 lg:w-[188px] lg:h-[149px]"
            /> */}
            <RenderImage
              src={image}
              className="object-cover w-full h-auto md:w-32 rounded-[4px] sm:w-40 sm:h-32 lg:w-[188px] lg:h-[149px]"
            />
          </div>
        </div>
      </div>

      {/* Card - Right Section */}
      <div className="flex flex-col w-full gap-4">
        <div className="flex flex-row justify-between">
          <div>
            <div className="flex flex-col gap-1">
              <h3 className="font-semibold text-dark font-inter text-[15px] md:text-[20px] leading-6">
                {title}
              </h3>
              <p className="font-normal leading-[20px] text-[#4A4A4A] font-inter text-level-7">
                {location}
              </p>
              <div className="flex flex-row gap-[10px] flex-wrap">
                {jobTasks.map((task, index) => (
                  <button
                    key={index}
                    className="border border-[#CBD5E0] rounded-[20px] px-2 sm:px-3 py-2 text-[12px] sm:text-sm bg-[#FAFAFA] text-[#404145] leading-[14.52px]"
                  >
                    {task}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="hidden lg:block md:block">
            <p className="text-[var(--subtle-text)] font-inter font-semibold leading-6 text-[18px]">
              <TimeCalculator date={lastUpdatedDate} />
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-between gap-4 lg:flex-row md:flex-row">
          <div className="flex flex-row gap-20">
            <div className="text-[#4A4A4A] font-inter leading-[24px]">
              <h3 className="font-semibold text-[14px]">Date</h3>
              <p className="text-[12px]">{formattedDate}</p>
            </div>
            <div className="text-[#4A4A4A] font-inter leading-[24px]">
              <h3 className="font-semibold text-[14px]">Time</h3>
              <p className="text-[12px]">{formattedTime}</p>
            </div>
          </div>
          <div className="flex items-center justify-center sm:justify-end">
            {/* <button className="px-[60px] font-semibold font-inter leading-[17px] text-[#0F161E] border border-gray-300 rounded-lg py-2">
                Chat Now
              </button> */}
            <Button
              buttonText="Chat Now"
              className="px-[60px] font-semibold font-inter leading-[17px] text-[#0F161E] border border-gray-300 rounded-lg py-2"
              textColor="black"
              width="281px"
              loading={isCreateThread}
              onClick={() => {handleStartChat(createdBy?.toString())}}
              disabled={createdBy?.toString() === userState?._id?.toString()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskerFeedJobCard;
